import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ParallaxProvider } from 'react-scroll-parallax';

import Title from "../Ziplyne-application/title";
import Mountain from "../Ziplyne-application/mountain";
import Slide from "./slide";
import Half from "../Ziplyne-application/half";
import Video from "../Ziplyne-application/video";
import Statistics from "../Ziplyne-application/statistics";

import screenshot from "./images/Salesforce-Screenshot.svg";
import salesforce from "./images/salesforcegraphic.svg";
import video from "./images/Salesforce Video.webm";

import './main.css';

function Ziplyne_for_salesForce() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif',
            subtitle1: {
                fontWeight: 600,
            }
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Helmet>
                <title>Ziplyne for Salesforce</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <main>
                            <Title title="Does keeping up with Salesforce feel like a grind? Perhaps your trail would benefit from a Ziplyne." img={salesforce} />
                            <div className="combined-background">
                                <Mountain small={screenIsSmall} title="Is this your Salesforce Experience...Day By Day, Entry By Entry?" />
                                <Half screenshot={screenshot} />
                                <Slide />
                            </div>
                            <Video
                                header="Let Ziplyne empower your Salesforce: Easy to Use…Easy to Manage!"
                                video={video}
                            />
                            <Statistics />
                        </main>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    );
}

export default Ziplyne_for_salesForce;
